import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ship3',
  templateUrl: './ship3.component.html',
  styleUrls: ['./ship3.component.css']
})
export class Ship3Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
